module.exports = __webpack_public_path__ + "static/media/icn_critical_illness_fisdom.f91391de.svg";